import React, { useCallback } from 'react'
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';
import {
  Edit,
  TextInput,
  required,
  minLength,
  maxLength,
  TabbedForm,
  FormTab,
  ReferenceField,
  useRecordContext,
  SimpleShowLayout,
} from 'react-admin';
import { CopyToChipboardField } from '../../components';
import { QRCodeSVG } from 'qrcode.react';
import { Alert } from '@mui/material';

const GroupLinkButton: React.FC<any> = ({ label }) => {

  const outerRecord = useRecordContext();
  if (!outerRecord) return null;
  const { id } = outerRecord;

  const ButtonLink = () => {
    const record = useRecordContext();
    if (!record) return null;

    const getGroupLink = useCallback(() => {
      return `https://${record.code}-app.pontuax.com.br/?customerGroupId=${id}`;
    }, [record]);

    return (
      <>
        <SimpleShowLayout sx={{ padding: 0 }} record={{ ...record, groupLink: getGroupLink() }}>
          <QRCodeSVG
            value={getGroupLink()}
            bgColor="#ffffff"
            fgColor="#000000"
            size={256}
          />
          <CopyToChipboardField source="groupLink" label={label} showClipButton />
        </SimpleShowLayout>
      </>
    );
  }

  return (
    <ReferenceField source="chainId" reference="chains" link={false}>
      <ButtonLink />
    </ReferenceField>
  );
}

const EditCustomerGroup = (props) => {
  return (
    <Permission permission={PERMISSIONS.CUSTOMER_GROUPS}>
      <Edit {...props} title='Editar grupo de clientes'>
        <TabbedForm>
          <FormTab label="Identificação">
            <Alert severity="info" sx={{ mb: 2, maxWidth: 620 }}>
              ✨ <strong>Novidade: agora usamos Etiquetas.</strong> Os grupos deram lugar às etiquetas — mais
              flexíveis, porque um mesmo cliente pode ter <strong>várias</strong> etiquetas (antes era só um
              grupo). Crie e gerencie tudo em <strong>Etiquetas</strong>.
            </Alert>
            <TextInput source="name" label="Nome" validate={[required(), minLength(3), maxLength(240)]} InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
            <TextInput source="description" label="Descrição" validate={[required(), minLength(3), maxLength(240)]} InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
            <GroupLinkButton label="Link de convite" />
          </FormTab>
        </TabbedForm>
      </Edit>
    </Permission>
  );
};

export default EditCustomerGroup;
